import React, { useState } from "react";
import POSProductList from "../pages/POSProductList";
import CartSidebar from "../components/cart/CartSidebar";
import { POSProductsProvider } from "../contexts/POSProductContext";
import { CartProvider } from "../contexts/cartContext";
import { useCart } from "../contexts/cartContext";
import { ShoppingCart } from "lucide-react";

export default function Dashboard() {
    const [cartOpen, setCartOpen] = useState(false);
    const { cart, cartCountHighlight } = useCart();
    const cartCount = cart.reduce((sum, i) => sum + (Number(i.qty) || 0), 0);

    return (
        <POSProductsProvider>
            <CartProvider>
                <div className="flex flex-1 gap-6 overflow-hidden">
                    <main className="flex-1 overflow-y-auto scrollbar-thin">
                        <POSProductList />
                    </main>
                    <aside className="hidden sm:flex w-72 flex-col">
                        <CartSidebar />
                    </aside>
                </div>

                {/* Mobile: floating cart button */}
                <button
                    type="button"
                    onClick={() => setCartOpen(true)}
                    className="sm:hidden fixed bottom-4 right-4 z-[50] bg-[var(--color-primary)] text-[var(--color-on-primary)] w-12 h-12 rounded-full shadow-lg flex items-center justify-center"
                    aria-label="Open cart"
                >
                    <ShoppingCart size={20} />
                    {cartCount > 0 && (
                        <span
                            className={`absolute -top-1 -right-1 text-[10px] font-bold rounded-full px-1.5 py-0.5 transition-transform text-white bg-red-600 ${cartCountHighlight ? "scale-125" : "scale-100"}`}
                        >
                            {cartCount}
                        </span>
                    )}
                </button>

                {/* Mobile: slide-up cart drawer */}
                {cartOpen && (
                    <div className="sm:hidden fixed inset-0 z-[80]">
                        <div
                            className="absolute inset-0 bg-black/40"
                            onClick={() => setCartOpen(false)}
                        />
                        <div className="absolute inset-x-0 bottom-0 bg-white rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col">
                            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                                <h3 className="text-base font-semibold text-gray-900">Cart</h3>
                                <button
                                    type="button"
                                    onClick={() => setCartOpen(false)}
                                    className="text-sm font-semibold text-gray-600 hover:text-gray-800"
                                >
                                    Close
                                </button>
                            </div>
                            <div className="overflow-y-auto">
                                <CartSidebar />
                            </div>
                        </div>
                    </div>
                )}
            </CartProvider>
        </POSProductsProvider>
    );
}
